import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import invitationSlice from "./features/setting/invitationSlice";
import settingSlice from "./features/setting/settingSlice";
import userSlice from "./features/setting/userSlice";
import reviewSlice from "./features/reviews/reviewSlice";
import permissionSlice from "./features/setting/permissionSlice";
import apiSlice from "./features/setting/apiSlice";
// Config for persisting the user slice
const userPersistConfig = {
  key: "user",
  storage,
};

// Persisted reducers
const persistedUserReducer = persistReducer(userPersistConfig, userSlice);

// Combine the reducers
const rootReducer = combineReducers({
  user: persistedUserReducer,
  setting: settingSlice,
  invitation: invitationSlice,
  reviews: reviewSlice,
  getPermission: permissionSlice,
  loader: apiSlice, // Ensure apiSlice is added here

  // Uncomment if error slice is needed
  // error: errorSlice,
});

const store = configureStore({
  reducer: rootReducer,
});

export const persistor = persistStore(store);
export default store;
